import {
  CookieConsentPrefs,
  isAnalyticsCookiesEnabled,
  useLocale,
} from '@b2c/hooks';
import { useEffect, useState } from 'react';
import { Button, Cell, Flex, Popup, Switch, Typography } from 'react-vant';
import styles from './cookie-consent.module.less';

export interface CookieConsentModalProps {
  open: boolean;
  closable?: boolean;
  onClose?: () => void;
  onSave: (prefs: CookieConsentPrefs) => void;
}

export function CookieConsentModal({ open, closable = false, onClose, onSave }: CookieConsentModalProps) {
  const t = useLocale();
  const [analyticsCookies, setAnalyticsCookies] = useState(isAnalyticsCookiesEnabled());

  useEffect(() => {
    if (open) {
      setAnalyticsCookies(isAnalyticsCookiesEnabled());
    }
  }, [open]);

  function handleSave() {
    onSave({ allowAnalyticsCookies: analyticsCookies });
  }

  function handleAcceptAll() {
    onSave({ allowAnalyticsCookies: true });
  }

  return (
    <Popup
      visible={open}
      round
      position="bottom"
      closeable={closable}
      closeOnClickOverlay={closable}
      onClose={onClose}
      safeAreaInsetBottom
    >
      <div className={styles.cookieConsent}>
        <div className={styles.header}>
          <Typography.Title level={4}>{t('Title_CookieConsent')}</Typography.Title>
          <Typography.Text type="secondary">
            {t('Text_CookieConsent_Intro')}
          </Typography.Text>
        </div>

        <div className={styles.categories}>
          <Cell
            title={t('Title_CookieConsent_EssentialCookies')}
            label={t('Text_CookieConsent_EssentialCookies')}
            rightIcon={<Switch checked disabled size={20} />}
          />
          <Cell
            title={t('Title_CookieConsent_AnalyticsCookies')}
            label={t('Text_CookieConsent_AnalyticsCookies')}
            rightIcon={<Switch checked={analyticsCookies} onChange={setAnalyticsCookies} size={20} />}
          />
        </div>

        <div className={styles.footer}>
          <Flex gutter={8} className={styles.secondaryBtns}>
            <Flex.Item span={12}>
              <Button block round onClick={handleSave}>
                {t('Button_Confirm')}
              </Button>
            </Flex.Item>
            <Flex.Item span={12}>
              <Button block round type="primary" onClick={handleAcceptAll}>
                {t('Label_AcceptAllCookies')}
              </Button>
            </Flex.Item>
          </Flex>
        </div>
      </div>
    </Popup>
  );
}
